// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__UdWtz","rightAdornment":"Header_rightAdornment__2F5HK"};